import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { MessageText, CloseMessageButton } from "./styles/message-styles";
import { ErrorMessageWrapper, Emoji } from "./styles/error-message-styles";

const ErrorMessage = ({ errors, showError, clearError }) => (
  <ErrorMessageWrapper showError={showError}>
    <Emoji>
      <span role="img" aria-label="error-emoji">
        ⚠️
      </span>
    </Emoji>
    <MessageText>
      <div>{showError && errors.message && `Message ${errors.message}`}</div>
      <div>
        {showError &&
          errors.action_at &&
          `Interview start time ${errors.action_at}`}
      </div>
      <div>
        {showError &&
          errors.action_end_at &&
          `Interview end time ${errors.action_end_at}`}
      </div>
    </MessageText>
    <CloseMessageButton
      onClick={clearError}
      onKeyPress={clearError}
      role="button"
      tabIndex="0"
    >
      <FontAwesomeIcon icon={faTimes} />
    </CloseMessageButton>
  </ErrorMessageWrapper>
);

ErrorMessage.propTypes = {
  clearError: PropTypes.func.isRequired,
  showError: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    message: PropTypes.string,
    action_at: PropTypes.string,
    action_end_at: PropTypes.string,
  }),
};

ErrorMessage.defaultProps = {
  errors: null,
};

export default React.memo(ErrorMessage);
